"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$tableStruct = exports.tableStructToLines = exports.tableToLines = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const error_1 = require("../../cst/error");
const inline_1 = require("../../../node/cst/inline");
const util_2 = require("../../../util");
const _remarks_1 = __importStar(require("./$remarks"));
const columnsOrSentences_1 = require("./columnsOrSentences");
const _any_1 = require("./$any");
const _sentencesArray_1 = require("../../cst/rules/$sentencesArray");
const el_1 = require("../../../node/el");
const _article_1 = __importDefault(require("./$article"));
const _articleGroup_1 = __importDefault(require("./$articleGroup"));
const _paragraphItem_1 = require("./$paragraphItem");
const _figStruct_1 = __importDefault(require("./$figStruct"));
const util_3 = require("../../cst/util");
const controls_1 = require("../../../node/el/controls");
/**
 * The renderer for {@link std.Table}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$tableStruct.spec.ts) for examples.
 */
const tableToLines = (table, indentTexts) => {
    const lines = [];
    for (const row of table.children) {
        for (const [i, cell] of row.children.entries()) {
            const newIndentTexts = i === 0 ? indentTexts : [...indentTexts, toCSTSettings_1.default.INDENT];
            // const columnsOrSentences: (std.Column | std.Sentence)[] = [];
            const cellLine = new line_1.TableColumnLine({
                range: null,
                indentTexts: newIndentTexts,
                firstColumnIndicator: i == 0 ? "*" : "",
                midIndicatorsSpace: i == 0 ? " " : "",
                columnIndicator: (0, std_1.isTableHeaderColumn)(cell) ? "*" : "-",
                midSpace: " ",
                attrEntries: [],
                multilineIndicator: "",
                sentencesArray: [],
                lineEndText: toCSTSettings_1.default.EOL,
            });
            for (const [name, value] of Object.entries(cell.attr)) {
                if (std.defaultAttrs[cell.tag][name] === value)
                    continue;
                cellLine.attrEntries.push(new inline_1.AttrEntry(`[${name}="${value}"]`, [name, value], null, "", null));
            }
            lines.push(cellLine);
            const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT, toCSTSettings_1.default.INDENT];
            if ((0, std_1.isTableColumn)(cell)) {
                if (cell.children.every(std_1.isColumn)) {
                    cellLine.sentencesArray.push(...(0, columnsOrSentences_1.columnsOrSentencesToSentencesArray)(cell.children));
                }
                else if (cell.children.every(std_1.isSentence)) {
                    if (cell.children.length === 1) {
                        cellLine.sentencesArray.push(...(0, columnsOrSentences_1.columnsOrSentencesToSentencesArray)(cell.children));
                    }
                    else {
                        cellLine.multilineIndicator = "|";
                        if (cellLine.attrEntries.length > 0) {
                            cellLine.attrEntries.slice(-1)[0].trailingSpace = " ";
                        }
                        for (const child of cell.children) {
                            const sentencesArray = (0, columnsOrSentences_1.columnsOrSentencesToSentencesArray)([child]);
                            if (sentencesArray[0].attrEntries.length > 0) {
                                sentencesArray[0].attrEntries.slice(-1)[0].trailingSpace = " ";
                            }
                            lines.push(new line_1.TableColumnLine({
                                range: null,
                                indentTexts: childrenIndentTexts,
                                firstColumnIndicator: "",
                                midIndicatorsSpace: "",
                                columnIndicator: "-",
                                midSpace: " ",
                                attrEntries: [],
                                multilineIndicator: "",
                                sentencesArray,
                                lineEndText: toCSTSettings_1.default.EOL,
                            }));
                        }
                    }
                }
                else {
                    cellLine.multilineIndicator = "|";
                    if (cellLine.attrEntries.length > 0) {
                        cellLine.attrEntries.slice(-1)[0].trailingSpace = " ";
                    }
                    for (const child of cell.children) {
                        lines.push(...(0, _any_1.anyToLines)(child, childrenIndentTexts));
                        lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    }
                }
            }
            else {
                cellLine.sentencesArray.push(...(0, columnsOrSentences_1.columnsOrSentencesToSentencesArray)([(0, std_1.newStdEL)("Sentence", {}, cell.children)]));
            }
        }
    }
    return lines;
};
exports.tableToLines = tableToLines;
/**
 * The renderer for {@link std.TableStruct}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$tableStruct.spec.ts) for examples.
 */
const tableStructToLines = (tableStruct, indentTexts, options) => {
    const { withControl, } = {
        withControl: false,
        ...options,
    };
    const lines = [];
    const tableStructTitleSentenceChildren = tableStruct.children.find(el => el.tag === "TableStructTitle")?.children;
    const requireControl = withControl || Boolean(tableStructTitleSentenceChildren) || tableStruct.children.length !== 1 || tableStruct.children[0].tag !== "Table";
    if (requireControl) {
        lines.push(new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [
                new inline_1.Control(":table-struct:", null, "", null),
            ],
            sentencesArray: tableStructTitleSentenceChildren ? [
                new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, tableStructTitleSentenceChildren)])
            ] : [],
            lineEndText: toCSTSettings_1.default.EOL,
        }));
        lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
    }
    const childrenIndentTexts = requireControl ? [...indentTexts, toCSTSettings_1.default.INDENT] : indentTexts;
    for (const child of tableStruct.children) {
        if (child.tag === "TableStructTitle")
            continue;
        if (child.tag === "Table") {
            const tableLines = (0, exports.tableToLines)(child, childrenIndentTexts);
            lines.push(...tableLines);
            if (requireControl)
                lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if (child.tag === "Remarks") {
            const remarksLines = (0, _remarks_1.remarksToLines)(child, childrenIndentTexts);
            lines.push(...remarksLines);
            if (requireControl)
                lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.tableStructToLines = tableStructToLines;
const $tableCellChildrenBlock = (0, util_1.makeDoubleIndentBlockWithCaptureRule)("$tableCellChildrenBlock", (factory_1.factory
    .choice(c => c
    .orSequence(s => s
    .and(r => r.choice(c => c
    .or(() => _articleGroup_1.default) // Resets indentation
    .or(() => _article_1.default)
    .or(() => _paragraphItem_1.$requireControlParagraphItem)
    .or(() => _figStruct_1.default)
    .or(() => _remarks_1.default)), "any")
    .action(({ any }) => ({ value: [any.value], errors: any.errors })))
    .or(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.TBL
        && item.line.firstColumnIndicator === "") {
        return {
            value: [
                (0, std_1.newStdEL)("Sentence", Object.fromEntries(item.line.attrEntries.map(e => e.entry)), (0, util_3.mergeAdjacentTextsWithString)(item.line.sentencesArray
                    .map(sa => [
                    new controls_1.__Text(sa.leadingSpace, sa.leadingSpaceRange),
                    ...sa.sentences.map(s => s.children).flat(),
                ])
                    .flat()), item.line.sentencesArrayRange)
            ],
            errors: [],
        };
    }
    else {
        return null;
    }
}))
    .or(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH) {
        return {
            value: (0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(item.line.sentencesArray),
            errors: [],
        };
    }
    else {
        return null;
    }
})))));
const $table = factory_1.factory
    .withName("table")
    .sequence(s => s
    .and(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.TBL) {
        return item;
    }
    else {
        return null;
    }
}), "line")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .andOmit(r => r.assert(({ line }) => line.line.multilineIndicator === "|"))
    // .andOmit(r => r
    //     .zeroOrOne(r => r
    //         .sequence(s => s
    //             .and(r => r.noConsumeRef(() => $indentBlock), "nextBlock")
    //             .andOmit(r => r.assert(({ nextBlock }) => {
    //                 console.log(JSON.stringify(nextBlock, null, 4));
    //                 return true;
    //             }))
    //         )
    //     )
    // )
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(() => $tableCellChildrenBlock, "block")
    // .andOmit(r => r.assert(({ block }) => {
    //     console.log(JSON.stringify(block, null, 2));
    //     return true;
    // }))
    // .andOmit(r => r
    //     .zeroOrOne(r => r
    //         .sequence(s => s
    //             .and(r => r.noConsumeRef(r => r.anyOne()), "nextBlock")
    //             .andOmit(r => r.assert(({ nextBlock }) => {
    //                 console.log(JSON.stringify(nextBlock, null, 4));
    //                 return true;
    //             }))
    //         )
    //     )
    // )
    .action(({ block }) => {
    const children = block.value.map(v => v.value).flat();
    if (children.every(std_1.isSentence)) {
        for (const [i, s] of children.entries()) {
            if (!("Num" in s.attr))
                s.attr.Num = (i + 1).toString();
        }
    }
    return {
        value: block.value.map(v => v.value).flat(),
        errors: [
            ...block.value.map(v => v.errors).flat(),
            ...block.errors,
        ]
    };
}))))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "tableColumnLines")
    .action(({ tableColumnLines }) => {
    const tableRows = [];
    const errors = [];
    for (const [tableColumnLine, tableColumnChildrenBlock] of tableColumnLines) {
        errors.push(...(tableColumnChildrenBlock?.errors ?? []));
        if (tableColumnLine.line.firstColumnIndicator === "*") {
            if (tableColumnLine.line.columnIndicator === "*") {
                const tableHeaderColumnChildren = [
                    ...(0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(tableColumnLine.line.sentencesArray),
                    ...(tableColumnChildrenBlock?.value ?? []),
                ];
                if (tableHeaderColumnChildren.length === 0) {
                    const pos = tableColumnLine.line.midSpaceRange?.[1] ?? null;
                    tableHeaderColumnChildren.push((0, std_1.newStdEL)("Sentence", {}, [], (pos !== null ? [pos, pos] : null)));
                }
                const pos = tableColumnLine.line.indentsEndPos;
                const range = (0, el_1.rangeOfELs)(tableHeaderColumnChildren) ?? (pos !== null ? [pos, pos] : null);
                if (range && pos !== null) {
                    range[0] = pos;
                }
                const tableRowChildren = [
                    (0, std_1.newStdEL)("TableHeaderColumn", Object.fromEntries(tableColumnLine.line.attrEntries.map(attrEntry => attrEntry.entry)), tableHeaderColumnChildren, range),
                ];
                const tableRow = (0, std_1.newStdEL)("TableHeaderRow", {}, tableRowChildren, (0, el_1.rangeOfELs)(tableRowChildren));
                tableRows.push(tableRow);
            }
            else if (tableColumnLine.line.columnIndicator === "-") {
                const tableColumnChildren = [
                    ...(0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(tableColumnLine.line.sentencesArray),
                    ...(tableColumnChildrenBlock?.value ?? []),
                ];
                if (tableColumnChildren.length === 0) {
                    const pos = tableColumnLine.line.midSpaceRange?.[1] ?? null;
                    tableColumnChildren.push((0, std_1.newStdEL)("Sentence", {}, [], pos ? [pos, pos] : null));
                }
                const pos = tableColumnLine.line.indentsEndPos;
                const range = (0, el_1.rangeOfELs)(tableColumnChildren) ?? (pos !== null ? [pos, pos] : null);
                if (range && pos !== null) {
                    range[0] = pos;
                }
                const tableRowChildren = [
                    (0, std_1.newStdEL)("TableColumn", Object.fromEntries(tableColumnLine.line.attrEntries.map(attrEntry => attrEntry.entry)), tableColumnChildren, range),
                ];
                const tableRow = (0, std_1.newStdEL)("TableRow", {}, tableRowChildren, (0, el_1.rangeOfELs)(tableRowChildren));
                tableRows.push(tableRow);
            }
            else {
                (0, util_2.assertNever)(tableColumnLine.line.columnIndicator);
            }
        }
        else if (tableColumnLine.line.firstColumnIndicator === "") {
            const tableRowOrNull = tableRows.length > 0 ? tableRows[tableRows.length - 1] : null;
            const tableRow = tableRowOrNull ?? (0, std_1.newStdEL)(tableColumnLine.line.columnIndicator === "*" ? "TableHeaderRow"
                : tableColumnLine.line.columnIndicator === "-" ? "TableRow"
                    : (0, util_2.assertNever)(tableColumnLine.line.columnIndicator));
            if (tableRowOrNull === null) {
                errors.push(new error_1.ErrorMessage("table: No first column indicator", tableColumnLine.line.firstColumnIndicatorRange ?? tableColumnLine.virtualRange));
                tableRows.push(tableRow);
            }
            else if ((0, std_1.isTableHeaderRow)(tableRowOrNull) !== (tableColumnLine.line.columnIndicator === "*")) {
                errors.push(new error_1.ErrorMessage("table: Column indicator mismatch", tableColumnLine.line.columnIndicatorRange ?? tableColumnLine.virtualRange));
            }
            if ((0, std_1.isTableHeaderRow)(tableRow)) {
                const tableHeaderColumnChildren = [
                    ...(0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(tableColumnLine.line.sentencesArray),
                    ...(tableColumnChildrenBlock?.value ?? []),
                ];
                if (tableHeaderColumnChildren.length === 0) {
                    const pos = tableColumnLine.line.midSpaceRange?.[1] ?? null;
                    tableHeaderColumnChildren.push((0, std_1.newStdEL)("Sentence", {}, [], pos ? [pos, pos] : null));
                }
                const pos = tableColumnLine.line.indentsEndPos;
                const range = (0, el_1.rangeOfELs)(tableHeaderColumnChildren) ?? (pos !== null ? [pos, pos] : null);
                if (range && pos !== null) {
                    range[0] = pos;
                }
                tableRow.children.push((0, std_1.newStdEL)("TableHeaderColumn", Object.fromEntries(tableColumnLine.line.attrEntries.map(attrEntry => attrEntry.entry)), tableHeaderColumnChildren, range));
            }
            else if ((0, std_1.isTableRow)(tableRow)) {
                const tableColumnChildren = [
                    ...(0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(tableColumnLine.line.sentencesArray),
                    ...(tableColumnChildrenBlock?.value ?? []),
                ];
                if (tableColumnChildren.length === 0) {
                    const pos = tableColumnLine.line.midSpaceRange?.[1] ?? null;
                    tableColumnChildren.push((0, std_1.newStdEL)("Sentence", {}, [], pos ? [pos, pos] : null));
                }
                const pos = tableColumnLine.line.indentsEndPos;
                const range = (0, el_1.rangeOfELs)(tableColumnChildren) ?? (pos !== null ? [pos, pos] : null);
                if (range && pos !== null) {
                    range[0] = pos;
                }
                tableRow.children.push((0, std_1.newStdEL)("TableColumn", Object.fromEntries(tableColumnLine.line.attrEntries.map(attrEntry => attrEntry.entry)), tableColumnChildren, range));
            }
            else {
                (0, util_2.assertNever)(tableRow);
            }
        }
        else {
            (0, util_2.assertNever)(tableColumnLine.line.firstColumnIndicator);
        }
    }
    for (const tableRow of tableRows) {
        tableRow.range = (0, el_1.rangeOfELs)(tableRow.children);
    }
    const table = (0, std_1.newStdEL)("Table", {}, tableRows, (0, el_1.rangeOfELs)(tableRows));
    return {
        value: table,
        errors,
    };
}));
const $tableStructChildrenBlock = (0, util_1.makeIndentBlockWithCaptureRule)("$tableStructChildrenBlock", (factory_1.factory
    .choice(c => c
    .or(() => $table)
    .or(() => _remarks_1.default))));
/**
 * The parser rule for {@link std.TableStruct}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$tableStruct.spec.ts) for examples.
 */
exports.$tableStruct = factory_1.factory
    .withName("tableStruct")
    .choice(c => c
    .orSequence(s => s
    .and(() => $table, "table")
    .action(({ table }) => {
    const tableStruct = (0, std_1.newStdEL)("TableStruct", {}, [table.value], (0, el_1.rangeOfELs)([table.value]));
    return {
        value: tableStruct,
        errors: table.errors,
    };
}))
    .orSequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        && item.line.controls.some(c => /^:table-struct:$/.exec(c.control))) {
        return item;
    }
    else {
        return null;
    }
}), "titleLine")
    .and(r => r
    .zeroOrOne(() => $tableStructChildrenBlock), "childrenBlock")
    .action(({ titleLine, childrenBlock }) => {
    const children = [];
    const errors = [];
    const tableStructTitleText = titleLine.line.sentencesArray.map(ss => [ss.leadingSpace, ...ss.sentences.map(s => s.text())]).flat().join("");
    const tableStructTitle = tableStructTitleText ? (0, std_1.newStdEL)("TableStructTitle", {}, [tableStructTitleText], titleLine.line.sentencesArrayRange) : null;
    if (tableStructTitle) {
        children.push(tableStructTitle);
    }
    if (childrenBlock) {
        children.push(...childrenBlock.value.flat().map(v => v.value).flat());
        errors.push(...childrenBlock.value.flat().map(v => v.errors).flat());
        errors.push(...childrenBlock.errors);
    }
    const pos = titleLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const tableStruct = (0, std_1.newStdEL)("TableStruct", {}, children, range);
    return {
        value: tableStruct,
        errors,
    };
})));
exports.default = exports.$tableStruct;
//# sourceMappingURL=$tableStruct.js.map